import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchListNotificationRequest,
  getBadgeNotificationRequest,
  readNotificationRequest,
  updateSettingNotificationRequest
} from "../store/actions";


export function useGetNotification() {
  const dispatch = useDispatch();
  const { loading, data, lastPage, params } = useSelector(
    (state: any) => state.Menu.notification || {}
  );

  const fetchData = (params: any) => {
    dispatch(
      fetchListNotificationRequest({
        page: params.page,
        page_size: 20,
        order_by: "created_at",
        order_dir: "desc",
      })
    );
  };

  useEffect(() => {
    fetchData({
      page: 1,
    });
  }, []);

  const reLoadList = (data: any) => {
    fetchData(data);
  };

  const loadMore = useCallback(() => {
    if (loading) {
      return;
    }
    params.page = params?.page + 1;
    fetchData(params);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.page, loading]);

  return {
    loading,
    data,
    reLoadList,
    loadMore,
    lastPage,
    params,
  };
}

export function useUpdateSettingNotification() {
  const dispatch = useDispatch();

  const handleUpdateSetting = (data: any) => {
    dispatch(updateSettingNotificationRequest(data));
  }

  return { handleUpdateSetting };
}

export function useReadNotification() {
  const dispatch = useDispatch();
  const readNotification = async (ids?: any ) => { //ids array
    dispatch(readNotificationRequest(ids));
  };

  return readNotification;
}


export function useGetBadgeNotification() {
  const dispatch = useDispatch();
  const userId = useSelector((state: any) => state.Auth.userInfo?.id);
  const badgeNotification = useSelector((state: any) => state.Menu.badgeNotification || 0);

  const fetchBadgeNotification = useCallback(() => {
    if (userId) {
      dispatch(getBadgeNotificationRequest());
    }
  }, [dispatch, userId]);

  return { badgeNotification, fetchBadgeNotification };
}